import React, { useEffect, useRef, useState } from 'react';
import { Html5QrcodeScanner, Html5QrcodeScanType } from 'html5-qrcode';

interface QRScannerProps {
  onScan: (decodedText: string) => void;
  isActive: boolean;
}

export const QRScanner: React.FC<QRScannerProps> = ({ onScan, isActive }) => {
  const scannerRef = useRef<Html5QrcodeScanner | null>(null);
  const [error, setError] = useState<string>('');

  useEffect(() => {
    if (isActive) {
      const scanner = new Html5QrcodeScanner(
        'qr-reader',
        {
          fps: 10,
          qrbox: { width: 250, height: 250 },
          supportedScanTypes: [Html5QrcodeScanType.SCAN_TYPE_CAMERA],
          rememberLastUsedCamera: true,
          showTorchButtonIfSupported: true,
        },
        false
      );

      scanner.render(
        (decodedText) => {
          onScan(decodedText);
          // Play success sound
          const audio = new Audio('data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2/LDciUFLIHO8tiJNwgZaLvt559NEAxQp+PwtmMcBjiR1/LMeSwFJHfH8N2QQAoUXrTp66hVFApGn+DyvmwhBSl+zPLXhjMGG2m98OScTgwOT6zn4bllHwU0jdXzzn8+Ci17yO7ckTYIHWq57OaiWA0NU6ro37ppHwU0jdT02YE7Cip8y/PdkTYIHWq57OahVwwOUK3p47RiFAUzjdXy0YM3Cixs0fLajzsKF2W27euiXhkKTahglLPwzIE0Cyxs0fLajzsKF2S27eqjWREMUKjt4rdmGAU3jdT02YE7Cip6ye/djTUIHWu57OaiWA0NU6vq4LVlHwU0jdXzzn8+Ci17yO7ckTYIHWu57OaiWA0NUqno4bllHwU1jdT02YE7Cip8y/PdkTYIHWq57OahVwwOUK3p47RiFAU0jdT02YE7Cip8y/PdkTYIHWu57OahVwwOU63p47RiFAU0jdT02YE7Cip8y/PdkTYIHWu57OahVwwOU63p47RiFAU0jdT02YE7Cip8y/PdkTYIHWu57OahVwwOU63p47RiFAU0jdT02YE7Cip8y/PdkTYIHWu57OahVwwOU63p47RiFAU0jdT02YE7Cip8y/PdkTYIHWu57OahVwwOU63p47RiFAU0jdT02YE7Cip8y/PdkTYIHWu57OahVwwOU63p47RiFAU0jdT02YE7Cip8y/PdkTYIHWu57OahVwwOU63p47RiFAU0jNT02YE7Cip8y/PdkTYIHWu57OahVwwOU63p47RiFAU0jNT02YE7Cip8y/PdkTYIHWu57OahVwwOU63p47RiFAU0jNT02YE7Cip8y/PdkTYIHWu57OahVwwOU63p47RiFAU0jNT02YE7Cip8y/PdkTYIHWu57OahVwwOU63p47RiFAU0jNT02YE7Cip8y/PdkTYIHWu57OahVwwOU63p47RiFAU0jNT02YE7Cip8y/PdkTYIHWu57OahVwwOUK3p47RiFAU0jNT02YE7Cip8y/PdkTYIHWu57OahVw==');
          audio.play().catch(() => {}); // Ignore errors if audio fails
        },
        (errorMessage) => {
          // Only show error if it's not about no camera being found initially
          if (!errorMessage.includes('No MultiFormat Readers')) {
            setError('');
          }
        }
      );

      scannerRef.current = scanner;
    }

    return () => {
      if (scannerRef.current) {
        scannerRef.current.clear().catch(console.error);
      }
    };
  }, [isActive, onScan]);

  return (
    <div className="w-full max-w-md mx-auto">
      <div id="qr-reader" className="w-full"></div>
      {error && (
        <div className="mt-4 p-4 bg-red-50 border border-red-200 rounded-lg">
          <p className="text-red-700">{error}</p>
        </div>
      )}
    </div>
  );
};